module.exports = __webpack_public_path__ + "static/media/logout.5da2bd06.svg";